import { Link as RouterLink } from "react-router-dom";
import { Stack, Card, CardActionArea, CardContent, Typography, Box } from "@mui/material";
import LockResetIcon from "@mui/icons-material/LockReset";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const items = [
  {
    to: "/settings/password",
    icon: LockResetIcon,
    label: "Change password",
    desc: "Update your account password."
  }
];

export default function Settings() {
  return (
    <Box sx={{ maxWidth: 720, mx: "auto" }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 700, letterSpacing: "-0.02em" }}>
        Settings
      </Typography>
      <Stack spacing={1.5}>
        {items.map(({ to, icon: Icon, label, desc }) => (
          <Card key={to}>
            <CardActionArea component={RouterLink} to={to}>
              <CardContent sx={{ display: "flex", alignItems: "center", gap: 2, py: 2 }}>
                <Icon sx={{ color: "text.secondary" }} />
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontWeight: 600 }}>{label}</Typography>
                  <Typography variant="body2" color="text.secondary">{desc}</Typography>
                </Box>
                <ChevronRightIcon sx={{ color: "text.secondary" }} />
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Stack>
    </Box>
  );
}
